
export const getTokenHeader = () => {
  const tokenHeader = {
    headers: {
      token: localStorage.getItem('cadess-ui-token')
    }
  };
  return tokenHeader;
};